import React, {useState} from "react";
import FormItem from "../../../components/FormItem";
import t from "../../../helpers/t";
import {Biscuit} from "../../../../utils";
import FEParamsDialog from "./Utils/FEParamsDialog";
// @ts-ignore
import {ADJUSTMENT_HELP_TEXT, HtmlTooltip} from "../../../../utils/HelperOld";
const BookingSettings = (props) => {
    const {  onChange, _showPopUp, setting } = props;
    const [showDialog, setShowDialog] = React.useState(false);
    const showFEParamsDialog = () => {
         setShowDialog(true);
    }
    const hideFEParamsDialog = () => {
        setShowDialog(false);
    }

    return (<>

        {Biscuit.get('client.isBikeSharing') !== 'true' &&
            <>
                <fieldset className='fieldBox'>
                    <label className="inb-form__controlLabel legendLabel">
                        <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Stornierung von Anfragen', null, 'capital')+'::'+t('cancel_requested_orders_info')+"//"}/>}</React.Fragment>}>
                            <a>
                                <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                            </a>
                        </HtmlTooltip>
                    </label>
                    <FormItem
                        type='checkbox'
                        value={setting.cancel_requested_orders}
                        id={setting.id}
                        name='cancel_requested_orders'
                        label={t('cancel requested orders')}
                        labelStyle={{minWidth: "230px"}}
                        htmlFor={t('cancel requested orders')}
                        mediumWidth="12"
                        smallWidth="12"
                        onChangeHandler={onChange}/>
                    <FormItem
                        type='time-input'
                        value={setting.cancel_requested_orders_time}
                        id={setting.id}
                        name='cancel_requested_orders_time'
                        label={t('after')}
                        labelStyle={{}}
                        mediumWidth="12"
                        smallWidth="12"
                        onChangeHandler={onChange}
                        unit="seconds"
                        extraTopClasses="float-left width100"
                    />
                </fieldset>
                <fieldset className='fieldBox'>
                    <label className="inb-form__controlLabel legendLabel">
                        <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Sende Erinnerungsmail zu Angeboten', null, 'capital')+'::'+t('send_reminder_mail_for_offers_info')+"//"}/>}</React.Fragment>}>
                            <a>
                                <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                            </a>
                        </HtmlTooltip>
                    </label>
                    <FormItem
                        type='checkbox'
                        value={setting.send_reminder_mail_for_offers}
                        id={setting.id}
                        name='send_reminder_mail_for_offers'
                        label={t('send reminder mail for offers')}
                        labelStyle={{minWidth: "230px"}}
                        htmlFor={t('send reminder mail for offers')}
                        mediumWidth="12"
                        smallWidth="12"
                        onChangeHandler={onChange}/>
                    <FormItem
                        type='time-input'
                        value={setting.reminder_time_for_offers}
                        id={setting.id}
                        name='reminder_time_for_offers'
                        label={t('after')}
                        labelStyle={{}}
                        mediumWidth="12"
                        smallWidth="12"
                        onChangeHandler={onChange}
                        unit="seconds"
                        extraTopClasses="float-left width100"
                    />
                </fieldset>
            </>
        }
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Automatische Stornerung er Buchung wenn kein Checkin erfolgt', null, 'capital')+'::'+t('cancelNoCheckin_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
            type='checkbox'
            value={setting.cancelNoCheckin}
            id={setting.id}
            name='cancelNoCheckin'
            label={t('cancel if no checkin')}
            labelStyle={{minWidth:"60%"}}
            htmlFor={t('cancel if no checkin')}
            mediumWidth="12"
            smallWidth="12"
            onChangeHandler={onChange} />
        <FormItem
            type='time-input'
            value={setting.cancelCheckinTime}
            id={setting.id}
            name='cancelCheckinTime'
            label={t('after')}
            labelStyle={{}}
            mediumWidth="12"
            smallWidth="12"
            onChangeHandler={onChange}
            unit="minutes"
            extraTopClasses="float-left width100"
        />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Pufferzeit zwischen zwei Buchungen', null, 'capital')+'::'+t('reservationBuffer_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
            type='time-input'
            value={setting.reservationBuffer}
            id={setting.id}
            name='reservationBuffer'
            label={t('reservation buffer')}
            labelStyle={{}}
            mediumWidth="12"
            smallWidth="12"
            onChangeHandler={onChange}
            unit="seconds"
        />
        </fieldset>
        <fieldset className='fieldBox'>
           <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Anzahl laufender Buchungen eines Nutzers', null, 'capital')+'::'+t('countOfBookings_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='input'
                value={setting.countOfBookings}
                id={setting.id}
                name='countOfBookings'
                label={t('count of bookings')}
                labelStyle={{marginRight:'20px',float:'left'}}
                inputStyle={{maxWidth:"60px"}}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
                inputType="number"
            />
            <br/>
            <FormItem
                type='input'
                value={setting.countOfBookingsAtSameTime}
                id={setting.id}
                name='countOfBookingsAtSameTime'
                label={t('count of bookings at same time')}
                labelStyle={{marginRight:'20px',float:'left'}}
                inputStyle={{maxWidth:"60px"}}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
                inputType="number"
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Auswahl Buchungstypen', null, 'capital')+'::'+t('show_usage_type_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.show_usage_type}
                id={setting.id}
                name='show_usage_type'
                label={t('show usage type')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('show usage type')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Vorrausbuchung möglich', null, 'capital')+'::'+t('pre_booking_possible_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.pre_booking_possible}
                id={setting.id}
                name='pre_booking_possible'
                label={t('prebooking possible')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('prebooking possible')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Buchungsende änderbar', null, 'capital')+'::'+t('end_changeable_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.end_changeable}
                id={setting.id}
                name='end_changeable'
                label={t('Buchungsende änderbar')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('Buchungsende änderbar')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
            />
        </fieldset>
        <fieldset className='fieldBox'>
             <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Maximale Buchungszeit', null, 'capital')+'::'+t('maxBookingTime_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='time-input'
                value={setting.maxBookingTime}
                id={setting.id}
                name='maxBookingTime'
                label={t('max booking time')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('max booking time')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
                unit="seconds"
                extraTopClasses="float-left width100"
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Benachrichtigung Kunde vor Ablauf Buchung', null, 'capital')+'::'+t('nearEndTimeMessage_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='time-input'
                value={setting.timeSendMailBeforeEnd}
                id={setting.id}
                name='timeSendMailBeforeEnd'
                label={t('time send mail before end')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('time send mail before end')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
                unit="seconds"
                extraTopClasses="float-left width100"
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Mietvertrag an der Auftragsbestätigung', null, 'capital')+'::'+t('with_ticket_on_message_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.withTicketOnMessage}
                id={setting.id}
                name='withTicketOnMessage'
                label={t('Mietvertrag an der Auftragsbestätigung')}
                labelStyle={{minWidth:"85%"}}
                htmlFor={t('Mietvertrag an der Auftragsbestätigung')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Automatischer Checkout', null, 'capital')+'::'+t('auto_checkout_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.autoCheckout}
                id={setting.id}
                name='autoCheckout'
                label={t('Automatischer Checkout (Abstellanlage)')}
                labelStyle={{minWidth:"87%"}}
                htmlFor={t('Automatischer Checkout (Abstellanlage)')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
            />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Stornierung durch Nutzer möglich', null, 'capital')+'::'+t('cancel_possible_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.cancelPossible}
                id={setting.id}
                name='cancelPossible'
                label={t('Stornierung durch Nutzer möglich')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('Stornierung durch Nutzer möglich')}
                mediumWidth={setting.cancelPossible?"6":"12"}
                smallWidth="12"
                onChangeHandler={onChange}
                extraTopClasses="float-left"
            />
            {setting.cancelPossible && <>
                <FormItem
                    type='checkbox'
                    value={setting.cancelAfterCheckinPossible}
                    id={setting.id}
                    name='cancelAfterCheckinPossible'
                    label={t('Stornierung nach dem Checkin möglich')}
                    labelStyle={{minWidth:"60%"}}
                    htmlFor={t('Stornierung nach dem Checkin möglich')}
                    mediumWidth="6"
                    smallWidth="12"
                    onChangeHandler={onChange}
                    extraTopClasses="float-left"
                />
                <FormItem
                    type='checkbox'
                    value={setting.cancelBeforeCheckinPossible}
                    id={setting.id}
                    name='cancelBeforeCheckinPossible'
                    label={t('Stornierung vor dem Checkin möglich')}
                    labelStyle={{minWidth:"60%"}}
                    htmlFor={t('Stornierung vor dem Checkin möglich')}
                    mediumWidth="6"
                    smallWidth="12"
                    onChangeHandler={onChange}
                    extraTopClasses="float-left"
                />
            </>}
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Automatischer PRE-Checkin', null, 'capital')+'::'+t('pre_auto_checkout_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.withAutoCheckin}
                id={setting.id}
                name='withAutoCheckin'
                label={t('Automatischer CheckIn zum Beginn')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('Automatischer CheckIn zum Beginn')}
                mediumWidth="6"
                smallWidth="12"
                onChangeHandler={onChange}
                extraTopClasses="float-left"
            />
                <FormItem
                    type='checkbox'
                    value={setting.withAutoCheckinCheckOut}
                    id={setting.id}
                    name='withAutoCheckinCheckOut'
                    label={t('Automatischer CheckOut zum Ende (voreingestellt)')}
                    labelStyle={{minWidth:"60%"}}
                    htmlFor={t('Automatischer CheckOut zum Ende (voreingestellt)')}
                    mediumWidth="6"
                    smallWidth="12"
                    onChangeHandler={onChange}
                    extraTopClasses="float-left"
                />
        </fieldset>
        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Geteilte Resourcen', null, 'capital')+'::'+t('shared_locations_for_resources_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <FormItem
                type='checkbox'
                value={setting.sharedLocationsForResources}
                id={setting.id}
                name='sharedLocationsForResources'
                label={t('Geteilte Resourcen')}
                labelStyle={{minWidth:"60%"}}
                htmlFor={t('Geteilte Resourcen')}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
            />
        </fieldset>

        <fieldset className='fieldBox'>
            <label className="inb-form__controlLabel legendLabel">
                <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('frontend url parameter', null, 'capital')+'::'+t('fronten_url_parameter_info')+"//"}/>}</React.Fragment>}>
                    <a>
                        <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                    </a>
                </HtmlTooltip>
            </label>
            <span style={{color:"red",paddingLeft: "30px"}}>Funktioniert noch nicht!</span>
            <FormItem
                type='inputWithSubmit'
                value={setting.frontend_url}
                id={setting.id}
                name='frontend_url'
                label={t('frontend url parameter', null, 'capital')}
                labelStyle={{marginRight:'20px',float:'left'}}
                inputStyle={{maxWidth:"250px",float:"left"}}
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChange}
                onClickHandler={showFEParamsDialog}
                inputType="text"
                buttonName={t("edit")}
                buttonTitle={t('edit')}
            />
        </fieldset>

        {showDialog &&
            <FEParamsDialog
                url={setting.frontend_url}
                handleCloseDialog={hideFEParamsDialog}
                onChange={onChange}
            />}
    </>)
}

export default BookingSettings;